import React from 'react';

import { InfoOutlined as InfoOutlinedIcon } from '@mui/icons-material';
import { Box, Tooltip } from '@mui/material';

import {
  WHATS_NEW_CAROUSEL_CTA_URL_HELPER_TEXT,
  fieldLabel,
} from '~/utils/societePayloadBuilder/whatsNewCarousel/fieldLabels';

import { PayloadBuilderTextField } from '../FormFields';

type WhatsNewCarouselCtaUrlFieldProps = Omit<React.ComponentProps<typeof PayloadBuilderTextField>, 'label'>;

function WhatsNewCarouselCtaUrlLabel() {
  return (
    <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
      {fieldLabel('ctaUrl')}
      <InfoOutlinedIcon fontSize="inherit" color="action" />
    </Box>
  );
}

export function WhatsNewCarouselCtaUrlField(props: WhatsNewCarouselCtaUrlFieldProps) {
  return (
    <Tooltip
      title={WHATS_NEW_CAROUSEL_CTA_URL_HELPER_TEXT}
      placement="top"
      arrow
      slotProps={{ tooltip: { sx: { whiteSpace: 'pre-line' } } }}
    >
      <Box sx={{ width: '100%' }}>
        <PayloadBuilderTextField label={<WhatsNewCarouselCtaUrlLabel />} {...props} />
      </Box>
    </Tooltip>
  );
}
